import React from 'react';
import InfoMaterialButton from '@medflex/components/stories/InfoMaterialButton';
import {
  IconDuplicate,
  IconQrCodeDocument,
  IconBrowserWindow,
} from '@medflex/components/stories/Icons';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import useIsWideScreen from '@medflex/hooks/useIsWideScreen';
import useModal from '../../hooks/useModal';

const MORE_INFORMATION_URL =
  'https://medflex.de/hilfe/behandler-kontaktseite/website-banner-aufsteller-flyer-fuer-die-praxis';

const InfoMaterialForPatientsModule = () => {
  const { open } = useModal();
  const { t } = useTranslation('messenger');
  const history = useHistory();
  const isWideScreen = useIsWideScreen();

  const handleQrCode = () => open({ modal: 'patientPermanentQRCode', action: 'print' });

  const handleMedflexOnYourHomepage = () => history.push('/snippets');

  const handleMoreInfoMaterials = () => window.open(MORE_INFORMATION_URL, '_blank');

  return (
    <div data-component="InfoMaterialForPatientsModule" className="flex flex-col">
      <header className="flex items-center mb-6">
        <h2 className="text-2xl font-semibold">{t('InfoMaterialForPatientsModule.title')}</h2>
      </header>
      <p className="mb-6">{t('InfoMaterialForPatientsModule.description')}</p>
      <InfoMaterialButton
        isWideScreen={isWideScreen}
        icon={<IconQrCodeDocument size="8" />}
        title={t('InfoMaterialForPatientsModule.qrCode')}
        subtitle={t('InfoMaterialForPatientsModule.qrCodeSubtitle')}
        onClick={handleQrCode}
        className="mb-6"
      />
      <InfoMaterialButton
        isWideScreen={isWideScreen}
        icon={<IconBrowserWindow size="8" />}
        title={t('InfoMaterialForPatientsModule.medflexOnYourHomepage')}
        subtitle={t('InfoMaterialForPatientsModule.medflexOnYourHomepageSubtitle')}
        onClick={handleMedflexOnYourHomepage}
        className="mb-6"
      />
      <InfoMaterialButton
        isWideScreen={isWideScreen}
        icon={<IconDuplicate size="8" />}
        title={t('InfoMaterialForPatientsModule.moreInfoMaterials')}
        subtitle={t('InfoMaterialForPatientsModule.moreInfoMaterialsSubtitle')}
        onClick={handleMoreInfoMaterials}
      />
    </div>
  );
};

export default InfoMaterialForPatientsModule;
